module.exports = __webpack_public_path__ + "img/155-israel.15668e72.svg";